import React from 'react'
import {
  IconInfoMarkCircle20Solid,
  LabeledContent,
  SegmentedControlGroup,
  SegmentedControlItem,
} from '@lightspeed/unified-components-helios-theme/react'
import { T } from '@transifex/react'
import {
  FulfilmentSelectProps,
  useFulfilmentSelectModel,
} from './useFulfilmentSelectModel'

export const FulfilmentSelect: React.FC<FulfilmentSelectProps> = props => {
  const model = useFulfilmentSelectModel(props)

  return (
    <div className="uc-base">
      <div className="flex flex-col gap-2">
        {props.outOfStockMessage && (
          <p className="typography-body-xs mb-2">{props.outOfStockMessage}</p>
        )}
        <p className="typography-body-sm-emphasized">
          {props.title || (
            <T _str="Fulfillment method" _context="Fulfilment select" />
          )}
        </p>
        <div>
          <SegmentedControlGroup
            layout={props.stretched ? 'fill' : 'hug'}
            name={model.fulfilmentTypeName}
            value={props.defaultType}
            onChange={model.handleChange}
          >
            {model.options.map(option => (
              <SegmentedControlItem
                customClasses={{
                  itemContainer: model.getItemContainerClass(option.type),
                }}
                customDataAttributes={{
                  itemContainer: {
                    'data-track': option.trackId,
                  },
                  itemHiddenInput: {
                    'data-track': option.trackId,
                  },
                }}
                disabled={model.getIsDisabled(option.type)}
                key={option.type}
                value={option.type}
              >
                {option.label}
              </SegmentedControlItem>
            ))}
          </SegmentedControlGroup>
        </div>
        {props.message && (
          <LabeledContent
            appearance="neutral"
            customClasses={{
              container: 'justify-start text-left',
              content: 'text-left',
            }}
            prefixSlot={
              <IconInfoMarkCircle20Solid
                aria-hidden
                className="size-4 fill-current"
              />
            }
            size="small"
          >
            {props.message}
          </LabeledContent>
        )}
      </div>
    </div>
  )
}

FulfilmentSelect.displayName = 'FulfilmentSelect'
